<template>
  <v-container max-width="100%" style="margin-top: 2%">

    <v-snackbar v-model="showSnackbar" :timeout="2000" color="red" dark>
      {{ mensagemSnackbar }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="showSnackbar = false">
          {{ $t('button.close') }}
        </v-btn>
      </template>
    </v-snackbar>

    <template>
      <v-row justify="center">
        <v-dialog v-model="confirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              <span style="color: #d60000">{{ $t('system.alert') }}</span>
            </v-card-title>
            <v-card-text>
              <span style="color: #d60000">{{ this.mensagemdialog }}</span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                this.messageDismissButton }}</v-btn>
              <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="confirm">{{
                this.messageConfirmButton }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <UpdateViagemDialog :viagem="viagem" :dialog="dialog" :map-key="key"
      @updated="viagemUpdated" @close="close"
      :motivo-conciliacao-manual-disabled="true"
      :observacoes-conciliacao-manual-disabled="true"
      :bloqueado-mes-fechado="viagemEditadaBloqueada"
      :aviso-mes-fechado="avisoViagemEditadaBloqueada"
      >
    </UpdateViagemDialog>

    <v-dialog v-model="despachanteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <strong style="color: #4a4a4a">{{ $t('system.alert') }}</strong>
        </v-card-title>
        <v-card-text>
          <span style="color: #4a4a4a">{{ $t('tripOperation.operationMessages.dispatcherTripExists') }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmDespachante(false)">{{ $t('button.dismiss') }}</v-btn>
          <v-btn color="primary" class="white--text" @click="confirmDespachante(true)">{{ $t('button.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRelatorio" fullscreen max-width="100%" style="z-index: 8000">
      <DetalhesViagem ref="detalheViagem" :linhas="linhas" :viagem="viagem" :user="user" :token="token"
        :tempo-real="true"
        :key="relatorioKey" @close="closeRelatorio"></DetalhesViagem>
    </v-dialog>

    <v-dialog v-model="proximasSaidasDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Atraso Máximo</span>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="5">
              <v-text-field
                v-model="atrasoMaximo"
                type="number"
                prepend-icon="mdi-clock"
                suffix="minutos"
                style="min-width: 200px;"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="filtrarProximasSaidas">Filtrar</v-btn>
          <v-btn color="primary" dark @click="proximasSaidasDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="selecionarLinhasDialog" max-width="500px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Selecione as Linhas</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="formSelecionarLinhas" v-model="selecionarLinhasValidado">
            <MultiplaEscolha
              ref="linhasSelect"
              lazy
              get-url="getLinhaslazy"
              text="cod_linha"
              value="id_linha"
              :label="$tc('line.self', 2)"
              icon="mdi-routes"
              :max-items="6"
              :can-toggle-all="true"
              :rules="[(v) => (v && v.length > 0) || 'Pelo menos uma linha deve ser selecionada']"
              v-bind:selected-items.sync="linhasSelecionadas"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark @click="selecionarLinhas">Carregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <merus-data-table
      :headers="headersWithActions"
      :items="filteredViagens"
      :loading="loading"
      :loading-text="$t('tripOperation.loadingTrips')"
      :items-per-page="itemsPerPage"
      :item-class="getViagemClass"
      :default-multi-sort="defaultMultiSortAssociadas"
      :show-columns-button="true"
      :table-height="'75vh'"
      :fixed-header="true"
      item-key="id_viagem_grid"
      @update:headers="headersChanged">
      <template v-slot:toolbar>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('tripOperation.operationTable') }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="selecionarLinhasDialog = true"
                v-on="on"
                v-bind="attrs"
                dark
                color="primary"
                style="margin-right: 5px;"
              >
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </template>
            <span>Selecionar Linhas</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                @click="filtroProximasSaidasClicked"
                v-on="on"
                v-bind="attrs"
                :dark="!mostrarProximasSaidas"
                :color="!mostrarProximasSaidas ? 'primary' : 'white'"
                style="margin-right: 5px;"
              >
                <v-icon>mdi-clock</v-icon>
              </v-btn>
            </template>
            <span>Proximas Saídas</span>
          </v-tooltip>
        </v-toolbar>
      </template>

      <template v-slot:item.numero_ordem_previsto="{ item }">
        <v-chip v-if="item.numero_ordem_previsto" :color="getColor(item)" dark @click="veiculoOfflineClicked(item)">
          {{ item.numero_ordem_previsto }}
        </v-chip>
      </template>

      <template v-slot:item.km_total="{ item }">
        <div>{{ item.km_total?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.diesel_total="{ item }">
        <div>{{ item.diesel_total?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.diesel_km="{ item }">
        <div>{{ item.diesel_km?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.eta_segundos="{ item }">
        <div>{{ getEtaFormatted(item.eta_segundos) }}</div>
      </template>

      <template v-slot:item.taxa_ocupacao="{ item }">
        <div>{{ item.taxa_ocupacao !== null ? `${item.taxa_ocupacao} %` : null }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="abrirViagem(item, 'ASSOCIADAS')"
          :disabled="!item.can_open">mdi-play</v-icon>
        <v-icon small class="mr-2" color="red" @click="fecharViagem(item, 'ASSOCIADAS')"
          :disabled="!item.can_close">mdi-stop</v-icon>
        <v-icon small class="mr-2" color="blue" @click="editViagem(item, 'ASSOCIADAS')"
          :disabled="!item.can_edit">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="orange" :disabled="!item.has_relatorio" @click="abrirPlotagemViagem(item)">mdi-map-marker</v-icon>
        <v-icon small class="mr-2" color="purple" @click="abrirRelatorioViagem(item)"
          :disabled="!item.dt_inicio">mdi-chart-timeline-variant</v-icon>
      </template>
    </merus-data-table>

    <merus-data-table
      :headers="headersNaoAssociadasWithProperties"
      :items="viagensNaoAssociadasFiltered"
      :loading="loadingNaoAssociadas"
      :loading-text="$t('tripOperation.loadingTrips')"
      :default-multi-sort="defaultMultiSortNaoAssociadas"
      :search="searchNaoAssociadas"
      item-key="id_viagem_realizada">
      <template v-slot:toolbar>
        <CadastroToolbar
          :title="$t('tripOperation.unassociatedTrips')"
          :items="viagensNaoAssociadasFiltered"
          :token="token"
          :user="user.id_usuario"
          csv-title="viagensnaoassociadas"
          :csv-headers="headersNaoAssociadasWithProperties"
          pdf-title="Viagens Não-Associadas"
          :pdf-headers="headersNaoAssociadasWithProperties"
          pdf-filename="viagensnaoassociadas"
          hide-search
        >
          <template v-slot:add>
            <v-btn color="primary" dark small class="mb-2" fab @click="adicionaViagemExtra">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
        </CadastroToolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="red" @click="fecharViagem(item, 'NAOASSOCIADAS')"
          :disabled="!item.can_close">mdi-stop</v-icon>
        <v-icon small class="mr-2" color="blue" @click="editViagem(item, 'NAOASSOCIADAS')">mdi-pencil</v-icon>
        <v-icon small class="mr-2" color="orange" :disabled="!item.has_relatorio" @click="abrirPlotagemViagem(item)">mdi-map-marker</v-icon>
        <v-icon small class="mr-2" color="purple" @click="abrirRelatorioViagem(item)"
          :disabled="!item.dt_inicio">mdi-chart-timeline-variant</v-icon>
      </template>
    </merus-data-table>
  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import axios from "axios";
import DetalhesViagem from "./DetalhesViagem.vue";
import DateUtils from "../utils/dateutils";
import { mapMutations } from "vuex";
import TranslateHeader from "../middleware/traducao/TranslateHeader.js";
import EventBus from "@/utils/eventBus";
import translateDbField from "@/utils/translateDbField";
import UpdateViagemDialog from "./Dialogs/UpdateViagemDialog.vue";
import fechamentoMesMixin from "@/mixins/fechamentoMesMixin";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";

export default {
  mixins: [fechamentoMesMixin],
  name: "QuadroViagens",
  components: {
    DetalhesViagem,
    UpdateViagemDialog,
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha,
  },
  props: {
    itemsPerPage: {
      type: Number,
      default() {
        return 10;
      }
    }
  },
  data: () => ({
    searchNaoAssociadas: "",
    searchPosicoes: "",
    showSnackbar: false,
    mensagemSnackbar: "",
    user: null,
    token: null,
    loading: false,
    loadingNaoAssociadas: false,
    confirmDialog: false,
    mensagemdialog: "",
    showConfirmButton: false,
    messageDismissButton: "",
    messageConfirmButton: "",
    operacao: null,
    formValidado: false,
    dialog: false,
    dialogRelatorio: false,
    horarioChegadaRealizadoDisabled: false,
    horarioSaidaRealizadoDisabled: false,
    guiaSelectDisabled: false,
    motivoSaidaDisabled: false,
    motivoChegadaDisabled: false,
    linhaDisabled: false,
    sentidoDisabled: false,
    cercaInicioDisabled: false,
    cercaChegadaDisabled: false,
    sublinhaDisabled: false,
    despachanteDialog: false,
    zoom: 12,
    timeProps: {
      useSeconds: true,
    },
    headers: [],
    viagens: [],
    viagensNaoAssociadas: [],
    viagensNaoAssociadasFiltered: [],
    guias: [],
    guiasFiltered: [],
    motivos: [],
    motivosViagem: [],
    status: [],
    recursos: [],
    empresasPermitidas: [],
    linhas: [],
    sublinhas: [],
    sublinhasFiltered: [],
    sentidos: [],
    cercasLinha: [],
    veiculos: [],
    linhaFiltro: null,
    linhaFiltroNaoAssociadas: null,
    editedIndex: -1,
    relatorioKey: 0,
    editedItem: {
      id_viagem_grid: null,
      id_viagem_prevista: null,
      horario_saida: null,
      horario_saida_previsto: null,
      horario_chegada: null,
      horario_chegada_previsto: null,
      escalonamento: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      id_viagem_realizada: null,
      dt_inicio: null,
      horario_saida_realizado: null,
      dt_fim: null,
      horario_chegada_realizado: null,
      id_veiculo: null,
      numero_ordem: null,
      id_motorista_validador: null,
      nome_motorista_validador: null,
      id_cobrador_validador: null,
      nome_cobrador_validador: null,
      id_linha: null,
      cod_linha: null,
      status: null,
      status_extenso: null,
      id_guia: null,
      guia_original: null,
      id_funcionario_motorista: null,
      nome_motorista: null,
      matricula_motorista: null,
      id_funcionario_cobrador: null,
      nome_cobrador: null,
      matricula_cobrador: null,
      dt_abertura_manual: null,
      id_usuario_abertura_manual: null,
      dt_fechamento_manual: null,
      id_usuario_fechamento_manual: null,
      dt_associacao_manual: null,
      id_usuario_associacao_manual: null,
      id_cerca_inicio: null,
      nome_cerca_inicio: null,
      cod_cerca_inicio: null,
      id_cerca_fim: null,
      nome_cerca_fim: null,
      cod_cerca_fim: null,
      dt_referencia: null,
      id_sublinha: null,
      nome_linha: null,
      id_classificacao: null,
      descricao_classificacao: null,
    },
    defaultItem: {
      id_viagem_grid: null,
      id_viagem_prevista: null,
      horario_saida: null,
      horario_saida_previsto: null,
      horario_chegada: null,
      horario_chegada_previsto: null,
      escalonamento: null,
      id_sentido: null,
      descricao_sentido: null,
      id_turno: null,
      descricao_turno: null,
      id_viagem_realizada: null,
      dt_inicio: null,
      horario_saida_realizado: null,
      dt_fim: null,
      horario_chegada_realizado: null,
      id_veiculo: null,
      numero_ordem: null,
      id_motorista_validador: null,
      nome_motorista_validador: null,
      id_cobrador_validador: null,
      nome_cobrador_validador: null,
      id_linha: null,
      cod_linha: null,
      status: null,
      status_extenso: null,
      id_guia: null,
      guia_original: null,
      id_funcionario_motorista: null,
      nome_motorista: null,
      matricula_motorista: null,
      id_funcionario_cobrador: null,
      nome_cobrador: null,
      matricula_cobrador: null,
      dt_abertura_manual: null,
      id_usuario_abertura_manual: null,
      dt_fechamento_manual: null,
      id_usuario_fechamento_manual: null,
      dt_associacao_manual: null,
      id_usuario_associacao_manual: null,
      id_cerca_inicio: null,
      nome_cerca_inicio: null,
      cod_cerca_inicio: null,
      id_cerca_fim: null,
      nome_cerca_fim: null,
      cod_cerca_fim: null,
      dt_referencia: null,
      id_sublinha: null,
      nome_linha: null,
      id_classificacao: null,
      descricao_classificacao: null,
    },
    itemDiario: {
      id_tipo_entrada_diario: null,
      id_motivo: null,
      id_linha: null,
      id_veiculo: null,
      id_viagem: null,
      dt_entrada: null,
      id_usuario_inclusao: null,
      dt_inclusao: null,
      id_usuario_edicao: null,
      dt_edicao: null,
      observacoes: null
    },
    defaultItemDiario: {
      id_tipo_entrada_diario: null,
      id_motivo: null,
      id_linha: null,
      id_veiculo: null,
      id_viagem: null,
      dt_entrada: null,
      id_usuario_inclusao: null,
      dt_inclusao: null,
      id_usuario_edicao: null,
      dt_edicao: null,
      observacoes: null
    },
    viagem: {
      id_viagem_grid: null,
      id_viagem_realizada: null,
      horario_saida_realizada: null,
      horario_chegada_realizada: null,
      id_guia_realizada: null,
      numero_guia_realizada: null,
      id_veiculo_realizado: null,
      numero_ordem_veiculo_realizado: null,
      escalonamento_veiculo: null,
      id_motorista_realizado: null,
      matricula_motorista_realizado: null,
      nome_motorista_realizado: null,
      id_cobrador_realizado: null,
      matricula_cobrador_realizado: null,
      nome_cobrador_realizado: null,
      id_sentido: null,
      id_cerca_inicio: null,
      nome_cerca_inicio: null,
      cod_cerca_inicio: null,
      id_cerca_fim: null,
      nome_cerca_fim: null,
      cod_cerca_fim: null,
      tempo_de_placa: null,
      passageiros_totais: null,
      passageiros_pagantes: null,
      passageiros_gratuidades: null,
      passageiros_vt: null,
      hodometro_inicial: null,
      dt_hodometro_inicial: null,
      hodometro_final: null,
      dt_hodometro_final: null,
      consumo_inicial: null,
      dt_consumo_inicial: null,
      consumo_final: null,
      dt_consumo_final: null,
      id_origem: null,
      temp_media: null,
      condicao_climatica: null,
      id_motivo_abertura_manual: null,
      observacoes_abertura_manual: null,
      id_motivo_fechamento_manual: null,
      observacoes_fechamento_manual: null,
      dt_abertura_manual: null,
      id_usuario_abertura_manual: null,
      dt_fechamento_manual: null,
      id_usuario_fechamento_manual: null,
      dt_associacao_manual: null,
      id_usuario_associacao_manual: null,
      id_linha_associada: null,
      cod_linha_associada: null,
    },
    entradasDiario: [],
    tiposEntradaDiario: [],
    dtEntradaDiario: null,
    loadingDiario: false,
    diarioForm: null,
    tipoEntradaDisabled: false,
    diarioFormValidado: false,
    viagensControladores: [],
    viagemAction: null,
    config: null,
    desassociarViagem: false,
    veiculoDisabled: false,
    atrasoMaximo: null,
    proximasSaidasDialog: false,
    mostrarProximasSaidas: false,
    linhasSelecionadas: [],
    selecionarLinhasDialog: false,
    selecionarLinhasValidado: false,
    key: 0,
    pollingActive: true,
    pollingCancelSource: null,
  }),
  computed: {
    /**
     * A viagem aberta no diálogo caiu num mês já fechado. É a tela de despacho, que trabalha
     * no dia corrente, então só acontece se o mês em curso tiver sido encerrado.
     */
    viagemEditadaBloqueada() {
      return this.viagemEmMesFechado(this.viagem, this.viagem && this.viagem.id_empresa);
    },
    avisoViagemEditadaBloqueada() {
      return this.avisoViagemMesFechado(this.viagem, this.viagem && this.viagem.id_empresa);
    },
    center() {
      return this.$store.getters['config/centerDefault'];
    },
    headersDiarioWithProperties() {
      return this.headersDiario.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    headersWithActions() {
      return [
        ...this.headers,
        { text: this.$t('tripOperation.actions'), value: 'actions', sortable: false, filtrable: false, show: true }
      ];
    },
    headersNaoAssociadasWithProperties() {
      return this.headersNaoAssociadas.map(header => ({
        ...header,
        filtrable: true,
        sortable: true
      }));
    },
    defaultMultiSortAssociadas() {
      return [
        { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        { value: 'id_turno', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        { value: 'horario_saida_previsto', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
    defaultMultiSortNaoAssociadas() {
      return [
        { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
        { value: 'dt_inicio', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
    formTitle() {
      if (this.operacao === 1) {
        return this.$t('tripOperation.openTrip');
      }

      if (this.operacao === 2) {
        return this.$t('tripOperation.closeTrip');
      }

      if (this.operacao === 3) {
        return this.$t('tripOperation.addTrip');
      }

      return this.$t('tripOperation.editTrip');
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('tripOperation.validation.dateRequired')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    headersDiario() {
      return [
      { text: this.$t('tripOperation.entryId'), value: "id_entrada_diario", align: " d-none" },
      { text: this.$t('tripOperation.date'), value: "dt_entrada" },
      { text: this.$t('tripOperation.type'), value: "descricao_tipo_entrada" },
      { text: this.$t('tripOperation.reason'), value: "descricao_motivo" },
      { text: this.$t('tripOperation.observations'), value: "observacoes" }];
    },
    headersNaoAssociadas() {
      return [
      { text: this.$t('tripOperation.tripId'), value: "id_viagem_realizada", align: " d-none" },
      { text: this.$t('tripOperation.classification'), value: "descricao_classificacao" },
      // { text: "Data", value: "data_extenso" },
      { text: this.$t('tripOperation.line'), value: "cod_linha" },
      { text: this.$t('tripOperation.guide'), value: "numero_guia" },
      { text: this.$t('tripOperation.vehicle'), value: "numero_ordem" },
      { text: this.$t('tripOperation.actualDepartureTime'), value: "horario_saida_realizado" },
      { text: this.$t('tripOperation.direction'), value: "descricao_sentido" },
      { text: this.$t('tripOperation.shift'), value: "descricao_turno" },
      { text: this.$t('tripOperation.scaling'), value: "escalonamento_veiculo" },
      { text: this.$t('tripOperation.actualArrivalTime'), value: "horario_chegada_realizado" },
      { text: this.$t('tripOperation.actualTripTime'), value: "tempo_viagem_realizada" },
      { text: this.$t('tripOperation.driver'), value: "nome_motorista" },
      { text: this.$t('tripOperation.conductor'), value: "nome_cobrador" },
      { text: this.$t('tripOperation.status'), value: "status_extenso" },
      { text: this.$t('tripOperation.actions'), value: "actions", sortable: false }
    ];
    },
    now() {
      return (new Date()).toLocaleDateString() + " " + (new Date()).toLocaleTimeString();
    },
    dtReferencia() {
      let dt = new Date();
      if (dt.toLocaleTimeString() <= this.config.hora_inicial_dia_operacao) {
        dt.setDate(dt.getDate() - 1);
      }

      return `${dt.getFullYear()}-${dt.getMonth()}-${dt.getDay()}`;
    },
    usaGuias() {
      return this.config?.usar_guias === 1;
    },
    veiculosSelect() {
      if (!Array.isArray(this.veiculos)) {
        return [];
      }
      return this.veiculos.filter((v) => v.id_veiculo === this.editedItem.id_veiculo || this.viagens.filter((vi) => vi.dt_fim === null).findIndex((vi) => vi.id_veiculo_realizado === v.id_veiculo) === -1);
    },
    filteredViagens() {
      if (this.mostrarProximasSaidas) {
        return this.viagens.filter((item) => {
          return item.dt_inicio === null && (item.tempo_atraso_saida === null || item.tempo_atraso_saida <= this.atrasoMaximo);
        });
      }

      return this.viagens;
    },
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.diarioForm) {
        this.$refs.diarioForm.resetValidation();
      }
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    selecionarLinhasDialog(val) {
      if (val) {
        this.$nextTick(() => this.syncLinhasSelect());
      }
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.initialize();
    this.populaSentidos();
  },
  beforeDestroy() {
    this.pollingActive = false;
    this.cancelPollingRequests();
    this.resetGrade(null);
  },
  methods: {
    ...mapMutations('timeout', [
      'resetGrade'
    ]),
    isPollingActive() {
      return this.pollingActive && !this._isDestroyed;
    },
    createPollingCancelToken() {
      if (!this.pollingCancelSource) {
        this.pollingCancelSource = axios.CancelToken.source();
      }
      return this.pollingCancelSource.token;
    },
    cancelPollingRequests() {
      if (this.pollingCancelSource) {
        this.pollingCancelSource.cancel('component destroyed');
        this.pollingCancelSource = null;
      }
    },
    schedulePolling(resetMutation, callback, delay) {
      if (!this.isPollingActive()) return;
      this[resetMutation](setTimeout(() => {
        if (!this.isPollingActive()) return;
        callback();
      }, delay));
    },
    translateHeader(header) {
      if (typeof header === 'object' && header.value) {
        const translationKey = `tripOperation.tableHeaders.${header.value}`;
        const translation = this.$t(translationKey);
        return translation !== translationKey ? translation : header.text;
      }
      
      return typeof header === 'string' ? header : header.text;
    },
    logout() {
      sessionStorage.removeItem("user");
      sessionStorage.removeItem("api");
      var id = window.setTimeout(function () { }, 0);
      while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
      }
      this.$router.push({ path: "/" });
    },
    initialize() {
      this.getConfig();
      this.getHeaders();
    },
    syncLinhasSelect() {
      const ref = this.$refs.linhasSelect;
      if (!ref) return;
      const selected = Array.isArray(this.linhasSelecionadas) ? [...this.linhasSelecionadas] : [];
      if (typeof ref.cacheSelectedItems === 'function' && Array.isArray(this.linhas) && this.linhas.length) {
        ref.cacheSelectedItems(
          this.linhas.filter((l) => selected.includes(l.id_linha)),
          'id_linha'
        );
      }
      if (typeof ref.setSelectedItems === 'function') {
        ref.setSelectedItems(selected);
      }
    },
    async selecionarLinhas() {
      if (!this.$refs.formSelecionarLinhas.validate()) {
        return;
      }

      const linhasRef = this.$refs.linhasSelect;
      if (linhasRef && typeof linhasRef.resolveSelection === 'function') {
        try {
          this.linhasSelecionadas = await linhasRef.resolveSelection();
        } catch (_err) {
          return;
        }
      }

      sessionStorage.setItem("linhasSelecionadas", JSON.stringify(this.linhasSelecionadas));
      this.populaViagens();
      this.populaViagensNaoAssociadas();
      this.selecionarLinhasDialog = false;
    },
    getConfig() {
      if (!this.isPollingActive()) return;
      apiController.request(apiController.endpoints.getallConfig, {
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.config = response.data[0];
          this.populaRecursos();
        },
        onError: (e) => {
          if (axios.isCancel(e)) return;
        },
      });
    },
      getHeaders() {
        let headersSession = JSON.parse(sessionStorage.getItem("headersGrid"))
        if (headersSession) {
          this.headers = headersSession.map(header => ({
            ...header,
            text: this.translateHeader(header)
          }));
        } else {
          apiController.request(apiController.endpoints.getHeaderstabela, {
            params: { cod: "GRIDVIAGENS" },
            silent: true,
            onSuccess: (response) => {
              console.log(response.data);
              this.headers = response.data.map(header => ({
                ...header,
                text: this.translateHeader(header)
              }));
              sessionStorage.setItem("headersGrid", JSON.stringify(this.headers));
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                this.mensagemAutorizacaoDialog = e.response.data.mensagem;
                this.autorizacaoDialog = true;
              }
            },
          });
        }

      this.headers = this.headers.map(header => ({
        ...header,
        text: TranslateHeader(header)
      }));
      },
      populaTiposEntrada() {
        apiController.request(apiController.endpoints.getallTiposentrada, {
          onSuccess: (response) => {
            this.tiposEntradaDiario = response.data
            this.tiposEntradaDiario.forEach(tipo => {
              tipo.descricao_tipo_entrada = translateDbField(
                tipo.translation_key,
                tipo.descricao_tipo_entrada
              );
              return tipo;
            });
          },
        });
    },
    populaViagens() {
      if (!this.isPollingActive()) return;
      this.loading = true;
      apiController.request(apiController.endpoints.getallViagens, {
        data: this.linhasSelecionadas,
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.viagens = response.data;
          this.viagens.forEach(viagem => {
            viagem.descricao_classificacao = translateDbField(
              viagem.translation_key,
              viagem.descricao_classificacao
            );
          });
          this.loading = false;
        },
        onError: (e) => {
          if (axios.isCancel(e) || !this.isPollingActive()) return;
          this.loading = false;
        },
      });
    },
    populaViagensNaoAssociadas() {
      if (!this.isPollingActive()) return;
      this.loadingNaoAssociadas = true;
      apiController.request(apiController.endpoints.getViagensnaoassociadas, {
        params: { config: this.config.hora_inicial_dia_operacao },
        config: { cancelToken: this.createPollingCancelToken() },
        onSuccess: (response) => {
          if (!this.isPollingActive()) return;
          this.viagensNaoAssociadas = response.data.filter((v) => this.linhasSelecionadas.includes(v.id_linha));
          this.viagensNaoAssociadas.forEach(viagem => {
            viagem.descricao_classificacao = translateDbField(
              viagem.translation_key,
              viagem.descricao_classificacao
            );
          });
          this.linhaFiltroNaoAssociadasChanged();
          this.loadingNaoAssociadas = false;
        },
        onError: (e) => {
          if (axios.isCancel(e) || !this.isPollingActive()) return;
          this.loadingNaoAssociadas = false;
        },
      });
    },
    populaViagensControladores() {
      let now = DateUtils.getDateSQLFormatted(new Date());
      let dti = DateUtils.getDateSQLFormatted(DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao)[0]);

      apiController.request(apiController.endpoints.getallViagenscontroladoresdata, {
        params: { dti, dtf: now },
        onSuccess: (response) => {
          this.viagensControladores = response.data;
        },
      });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        onSuccess: (response) => {
          this.veiculos = Array.isArray(response.data) ? response.data : [];
        },
        onError: () => {
          this.veiculos = [];
        },
      });
    },
    populaSentidos() {
      apiController.request(apiController.endpoints.getallSentidos, {
        onSuccess: (response) => {
          this.sentidos = response.data.map((sentido) => {
            const translated = translateDbField(
              sentido.translation_key,
              sentido.descricao_sentido
            );
            return {
              ...sentido,
              descricao_sentido: translated
            };
          });
        },
      });
    },
    populaGuias() {
      let date = new Date();
      let dtf = DateUtils.getDateSQLFormatted(date);
      date.setDate(date.getDate() - 2);
      let dti = DateUtils.getDateSQLFormatted(date);

      apiController.request(apiController.endpoints.getGuiasdata, {
        params: { dti, dtf },
        onSuccess: (response) => {
          this.guias = response.data.filter((g) => this.empresasPermitidas.includes(g.id_empresa));
        },
      });
    },
    populaMotivos() {
      apiController.request(apiController.endpoints.getallMotivos, {
        onSuccess: (response) => {
          this.motivos = response.data;
        },
      });
    },
    populaRecursos() {
      if (!this.isPollingActive()) return;
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          config: { cancelToken: this.createPollingCancelToken() },
          onSuccess: (response) => {
            if (!this.isPollingActive()) return;
            this.recursos = response.data;
            this.populaEmpresasPermitidas();
            this.populaLinhas();
            this.populaSublinhas();
            this.populaGuias();
            this.populaMotivos();
            this.populaTiposEntrada();
            this.populaViagensControladores();
            this.populaVeiculos();
          },
          onError: (e) => {
            if (axios.isCancel(e)) return;
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          config: { cancelToken: this.createPollingCancelToken() },
          onSuccess: (response) => {
            if (!this.isPollingActive()) return;
            this.recursos = response.data;
            this.populaEmpresasPermitidas();
            this.populaLinhas();
            this.populaGuias();
            this.populaMotivos();
            this.populaTiposEntrada();
            this.populaViagensControladores();
            this.populaVeiculos();
          },
          onError: (e) => {
            if (axios.isCancel(e)) return;
          },
        });
      }
    },
    populaEmpresasPermitidas() {
      this.empresasPermitidas = this.recursos.filter((r) => r.id_empresa).map((rec) => {
        return rec.id_empresa
      });
    },
    populaSublinhas() {
      apiController.request(apiController.endpoints.getallSublinhas, {
        onSuccess: (response) => {
          this.sublinhas = response.data;
        },
        onError: (e) => {
          console.log("Response : " + e.message);
        },
      });
    },
    populaLinhas() {
      if (!this.isPollingActive()) return;
      const gradeDelay = this.config.tempo_atualizacao_grade ? this.config.tempo_atualizacao_grade * 1000 : 60000;
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getLinhasativas, {
          config: { cancelToken: this.createPollingCancelToken() },
          onSuccess: (response) => {
            if (!this.isPollingActive()) return;
            this.linhas = response.data;

            if (this.linhasSelecionadas.length === 0) {
              this.linhasSelecionadas = sessionStorage.getItem("linhasSelecionadas") ? JSON.parse(sessionStorage.getItem("linhasSelecionadas")) : [];
            }

            if (this.linhasSelecionadas.length === 0 && this.$route.name !== "QuadroViagens") {
              this.linhasSelecionadas = this.linhas.map((linha) => linha.id_linha);
            }

            if (this.linhasSelecionadas.length > 0) {
              this.populaViagens();
              this.populaViagensNaoAssociadas();
              this.schedulePolling('resetGrade', () => this.populaLinhas(), gradeDelay);
            } else if (!this.selecionarLinhasDialog && this.$route.name === "QuadroViagens") {
              this.selecionarLinhasDialog = true;
            }
          },
          onError: (e) => {
            if (axios.isCancel(e) || !this.isPollingActive()) return;
          },
        });
      } else {
        apiController.request(apiController.endpoints.getLinhasoperacao, {
          config: { cancelToken: this.createPollingCancelToken() },
          onSuccess: (response) => {
            if (!this.isPollingActive()) return;
            this.linhas = response.data;

            if (this.linhasSelecionadas.length === 0) {
              this.linhasSelecionadas = sessionStorage.getItem("linhasSelecionadas") ? JSON.parse(sessionStorage.getItem("linhasSelecionadas")) : [];
            }

            if (this.linhasSelecionadas.length === 0 && this.$route.name !== "QuadroViagens") {
              this.linhasSelecionadas = this.linhas.map((linha) => linha.id_linha);
            }

            if (this.linhasSelecionadas.length > 0) {
              this.populaViagens();
              this.populaViagensNaoAssociadas();
              this.schedulePolling('resetGrade', () => this.populaLinhas(), gradeDelay);
            } else if (!this.selecionarLinhasDialog && this.$route.name === "QuadroViagens") {
              this.selecionarLinhasDialog = true;
            }
          },
          onError: (e) => {
            if (axios.isCancel(e) || !this.isPollingActive()) return;
          },
        });
      }
    },
    abrirViagem(item, tipo) {
      const viagens = tipo === 'ASSOCIADAS' ? this.filteredViagens : this.viagensNaoAssociadasFiltered;
      this.editedIndex = viagens.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.viagem = Object.assign({}, item);
      this.viagem.horario_saida_realizada = item.dt_inicio || item.horario_saida_prevista;
      this.viagem.horario_chegada_realizada = item.dt_fim || item.horario_chegada_prevista;
      this.operacao = 1;
      this.horarioChegadaRealizadoDisabled = true;
      this.horarioSaidaRealizadoDisabled = false;
      this.cercaInicioDisabled = false;
      this.cercaChegadaDisabled = true;
      this.sentidoDisabled = true;
      this.linhaDisabled = true;
      if (this.config.usar_guias == 1) {
        this.guiasFiltered = this.guias.filter((g) => this.editedItem.id_linha === g.id_linha && (g.dt_largada === null || g.dt_largada > this.now));
        this.guiaSelectDisabled = false;
        this.veiculoDisabled = true;
      } else {
        this.escalonamentoDisabled = false;
        this.veiculoDisabled = false;
      }
      this.itemDiario.id_tipo_entrada_diario = 1;
      this.dtEntradaDiario = new Date();
      this.tipoEntradaDisabled = true;
      this.sublinhasFiltered = this.sublinhas.filter((s) => s.id_linha_principal === this.editedItem.id_linha);
      this.populaEntradasDiario();
      this.populaCercasPorLinha(item.id_linha);

      let viagemDespachante = this.viagensControladores.find((v) => v.id_viagem_prevista == item.id_viagem_prevista);
      if (viagemDespachante) {
        this.viagemAction = 1;
        this.despachanteDialog = true;
      } else {
        this.key = this.key == 0 ? 1 : 0;
        this.dialog = true;
      }
    },
    confirmDespachante(choice) {
      let viagemDespachante = this.viagensControladores.find((v) => v.id_viagem_prevista == this.editedItem.id_viagem_prevista);

      if (choice) {
        if (this.viagemAction === 1) {
          this.editedItem.horario_saida_realizado = viagemDespachante.dt_saida_extenso;
          this.editedItem.id_guia = viagemDespachante.id_guia;
          this.editedItem.id_veiculo = viagemDespachante.id_veiculo;
          this.editedItem.id_cerca_inicio = viagemDespachante.id_cerca;
          this.editedItem.numero_ordem = viagemDespachante.numero_ordem;
        } else {
          this.editedItem.horario_chegada_realizado = viagemDespachante.dt_chegada_extenso;
          this.editedItem.id_cerca_fim = viagemDespachante.id_cerca;
        }
      }

      this.dialog = true;
      this.despachanteDialog = false;
    },
    fecharViagem(item, tipo) {
      const viagens = tipo === 'ASSOCIADAS' ? this.filteredViagens : this.viagensNaoAssociadasFiltered;
      this.editedIndex = viagens.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.operacao = 2;
      this.horarioChegadaRealizadoDisabled = false;
      this.horarioSaidaRealizadoDisabled = true;
      this.cercaChegadaDisabled = false;
      this.cercaInicioDisabled = true;
      this.linhaDisabled = true;
      this.sentidoDisabled = true;
      this.veiculoDisabled = true;
      if (this.config.usar_guias == 1) {
        this.guiasFiltered = this.guias.filter((g) => this.editedItem.id_linha === g.id_linha && (g.dt_largada === null || g.dt_largada > this.now));
        this.guiaSelectDisabled = false;
        this.guiaChanged();
      } else {
        this.escalonamentoDisabled = false;
      }
      this.itemDiario.id_tipo_entrada_diario = 1;
      this.dtEntradaDiario = new Date();
      this.tipoEntradaDisabled = true;
      this.sublinhasFiltered = this.sublinhas.filter((s) => s.id_linha_principal === this.editedItem.id_linha);
      this.populaEntradasDiario();
      this.populaCercasPorLinha(item.id_linha);

      let viagemDespachante = this.viagensControladores.find((v) => v.id_viagem_prevista == item.id_viagem_prevista);
      if (viagemDespachante) {
        this.viagemAction = 2;
        this.despachanteDialog = true;
      } else {
        this.dialog = true;
      }
    },
    editViagem(item, tipo) {
      const viagens = tipo === 'ASSOCIADAS' ? this.filteredViagens : this.viagensNaoAssociadasFiltered;
      this.editedIndex = viagens.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.viagem = Object.assign({}, item);
      this.viagem.horario_saida_realizada = item.dt_inicio || item.horario_saida_prevista;
      this.viagem.horario_chegada_realizada = item.dt_fim || item.horario_chegada_prevista;
      this.operacao = 4;
      this.horarioChegadaRealizadoDisabled = true;
      this.horarioSaidaRealizadoDisabled = true;
      this.cercaInicioDisabled = true;
      this.cercaChegadaDisabled = true;
      this.guiaSelectDisabled = true;
      this.veiculoDisabled = true;
      this.linhaDisabled = true;
      this.sentidoDisabled = true;
      this.tipoEntradaDisabled = false;
      this.dtEntradaDiario = new Date();
      this.guiasFiltered = this.guias;
      this.sublinhasFiltered = this.sublinhas.filter((s) => s.id_linha_principal === this.editedItem.id_linha);
      this.guiaChanged();
      this.key = this.key == 0 ? 1 : 0;
      this.dialog = true;
      // Meses fechados da empresa da viagem, para bloquear a edição de viagem congelada.
      this.carregaFechamentosMesAtivos(item.id_empresa);
      this.populaEntradasDiario();
      this.populaCercasPorLinha(item.id_linha);
    },
    close() {
      this.dialog = false;
      this.confirmDialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.viagem = Object.assign({}, this.defaultItem);
        this.viagem.horario_saida_realizada = null;
        this.viagem.horario_chegada_realizada = null;
        this.editedIndex = -1;
        this.horarioChegadaRealizadoDisabled = false;
        this.horarioSaidaRealizadoDisabled = false;
        this.motivoChegadaDisabled = false;
        this.motivoSaidaDisabled = false;
        this.guiaSelectDisabled = false;
        this.cercaInicioDisabled = false;
        this.cercaChegadaDisabled = false;
        this.linhaDisabled = false;
        this.sentidoDisabled = false;
        this.tipoEntradaDisabled = false;
        this.guiasFiltered = [];
        this.cercasLinha = [];
        this.motivosViagem = [];
        this.desassociarViagem = false;
        this.viagemAction = null;
        this.itemDiario = Object.assign({}, this.defaultItemDiario);
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        } else {
          this.formValidado = false;
        }
        if (this.$refs.diarioForm) {
          this.$refs.diarioForm.resetValidation();
        } else {
          this.diarioFormValidado = false;
        }
      })
    },
    confirm() {
      if (this.operacao === 1 || this.operacao === 3) {
        if (this.entradasDiario.filter((e) => e.id_tipo_entrada_diario == 1).length > 0) {
          this.editedItem.dt_inicio = DateUtils.getDateSQLFormatted(new Date()).substring(0, 10) + "T" + this.editedItem.horario_saida_realizado + ':00';
          this.editedItem.dt_abertura_manual = DateUtils.getDateSQLFormatted(new Date());
          this.editedItem.id_usuario_abertura_manual = this.user.id_usuario;

          let cerca_inicio = this.cercasLinha.find((c) => c.id_cerca == this.editedItem.id_cerca_inicio);
          this.editedItem.nome_cerca_inicio = cerca_inicio.nome_cerca;
          this.editedItem.cod_cerca_inicio = cerca_inicio.cod_cerca;

          if (this.usaGuias) {
            let guia = this.guias.find((g) => g.id_guia == this.editedItem.id_guia);
            this.editedItem.guia_original = guia.guia_original;
            this.editedItem.numero_ordem = guia.cod_veiculo;
            this.editedItem.escalonamento = guia.escalonamento;
            this.editedItem.id_funcionario_motorista = guia.id_motorista;
            this.editedItem.id_motorista_guia = guia.id_motorista;
            this.editedItem.nome_motorista_guia = guia.nome_motorista;
            this.editedItem.matr_motorista_guia = guia.matricula_motorista;
            this.editedItem.id_funcionario_cobrador = guia.id_cobrador;
            this.editedItem.id_cobrador_guia = guia.id_cobrador;
            this.editedItem.nome_cobrador_guia = guia.nome_cobrador;
            this.editedItem.matr_cobrador_guia = guia.matricula_cobrador;
            this.editedItem.nome_linha = guia.nome_linha;
            this.editedItem.cod_linha = guia.cod_linha;
            this.editedItem.turno_guia = guia.turno;
          } else {
            let veiculo = this.veiculos.find((v) => v.id_veiculo == this.editedItem.id_veiculo);
            console.log(veiculo);
            this.editedItem.numero_ordem = veiculo.cod_veiculo;
            this.editedItem.escalonamento = this.editedItem.escalonamento_viagem;
            this.editedItem.id_funcionario_motorista = veiculo.id_motorista_validador;
            this.editedItem.nome_funcionario_motorista = veiculo.nome_motorista_validador;
            this.editedItem.matr_funcionario_motorista = veiculo.matr_motorista_validador;
            this.editedItem.id_funcionario_cobrador = veiculo.id_cobrador_validador;
            this.editedItem.nome_funcionario_cobrador = veiculo.nome_cobrador_validador;
            this.editedItem.matr_funcionario_cobrador = veiculo.matr_cobrador_validador;
            let linha = this.linhas.find((l) => l.id_linha == this.editedItem.id_linha);
            this.editedItem.nome_linha = linha.nome_linha;
            this.editedItem.cod_linha = linha.cod_linha;
          }



          apiController.request(apiController.endpoints.insertViagemrealizada, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.showResult(response.data);
              this.preencheEntradas(response.data.insertId);
              this.initialize();
              this.close();
            },
          });
        } else {
          this.confirmDialog = false;
          this.mensagemSnackbar = this.$t('tripOperation.operationMessages.enterReason');
          this.showSnackbar = true;
        }
      }

      if (this.operacao === 2) {
        this.editedItem.dt_inicio = DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_inicio));
        this.editedItem.dt_abertura_manual = this.editedItem.dt_abertura_manual !== null ? DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_abertura_manual)) : null;
        this.editedItem.dt_associacao_manual = this.editedItem.dt_associacao_manual !== null ? DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_associacao_manual)) : null;
        this.editedItem.dt_fim = DateUtils.getDateSQLFormatted(new Date()).substring(0, 10) + "T" + this.editedItem.horario_chegada_realizado + ':00';
        this.editedItem.dt_fechamento_manual = DateUtils.getDateSQLFormatted(new Date());
        this.editedItem.id_usuario_fechamento_manual = this.user.id_usuario;

        let cerca_fim = this.cercasLinha.find((c) => c.id_cerca == this.editedItem.id_cerca_fim);
        this.editedItem.nome_cerca_fim = cerca_fim.nome_cerca;
        this.editedItem.cod_cerca_fim = cerca_fim.cod_cerca;

        if (this.entradasDiario.filter((e) => e.id_tipo_entrada_diario == 1).length > 0) {
          apiController.request(apiController.endpoints.updateViagemrealizada, {
            data: this.editedItem,
            onSuccess: (response) => {
              this.showResult(response.data);
              this.initialize();
              this.close();
            },
          });
        } else {
          this.confirmDialog = false;
          this.mensagemSnackbar = this.$t('tripOperation.operationMessages.enterReason');
          this.showSnackbar = true;
        }
      }

      if (this.operacao === 4) {
        if (this.desassociarViagem) {
          if (this.entradasDiario.filter((e) => e.id_tipo_entrada_diario != 1).length < 1) {
            this.confirmDialog = false;
            this.mensagemSnackbar = this.$t('tripOperation.operationMessages.enterDisassociationReason');
            this.showSnackbar = true;
            return null;
          } else {
            this.editedItem.viagem_desassociada = 1;
            this.editedItem.dt_associacao_manual = new Date().toISOString();
            this.editedItem.id_usuario_associacao_manual = this.user.id_usuario;
            this.editedItem.id_viagem_prevista = null;
          }
        }

        this.editedItem.dt_inicio = this.editedItem.dt_inicio !== null ? DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_inicio)) : null;
        this.editedItem.dt_fim = this.editedItem.dt_fim !== null ? DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_fim)) : null;
        this.editedItem.dt_abertura_manual = this.editedItem.dt_abertura_manual !== null ? DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_abertura_manual)) : null;
        this.editedItem.dt_associacao_manual = this.editedItem.dt_associacao_manual !== null ? DateUtils.getDateSQLFormatted(new Date(this.editedItem.dt_associacao_manual)) : null;

        apiController.request(apiController.endpoints.updateViagemrealizada, {
          data: this.editedItem,
          onSuccess: (response) => {
            this.showResult(response.data);
            this.initialize();
            this.close();
          },
        });
      }
    },
    save() {
      if (!this.formValidado) {
        this.$refs.form.validate();
      }

      if (this.formValidado) {
        if (this.operacao === 1) {
          this.mensagemdialog =
            this.$t('tripOperation.operationMessages.confirmOpening', { scheduledTime: this.editedItem.horario_saida_previsto, actualTime: this.editedItem.horario_saida_realizado });
          this.messageConfirmButton = this.$t('tripOperation.openTrip');
          this.messageDismissButton = this.$t('button.cancel');
          this.showConfirmButton = true;
          this.confirmDialog = true;
        }

        if (this.operacao === 2) {
          this.mensagemdialog =
            this.$t('tripOperation.operationMessages.confirmClosing', { scheduledTime: this.editedItem.horario_saida_previsto, actualTime: this.editedItem.horario_chegada_realizado });
          this.messageConfirmButton = this.$t('tripOperation.closeTrip');
          this.messageDismissButton = this.$t('button.cancel');
          this.showConfirmButton = true;
          this.confirmDialog = true;
        }

        if (this.operacao === 3) {
          this.mensagemdialog =
            this.$t('tripOperation.operationMessages.confirmAddition', { actualTime: this.editedItem.horario_saida_realizado });
          this.messageConfirmButton = this.$t('button.addIcon');
          this.messageDismissButton = this.$t('button.cancel');
          this.showConfirmButton = true;
          this.confirmDialog = true;
        }

        if (this.operacao === 4) {
          if (this.desassociarViagem) {
            this.mensagemdialog =
              this.$t('tripOperation.operationMessages.confirmDisassociation');
            this.messageConfirmButton = this.$t('button.disassociate');
            this.messageDismissButton = this.$t('button.cancel');
            this.showConfirmButton = true;
            this.confirmDialog = true;
          } else {
            this.confirm();
          }
        }
      }
    },
    horarioRules(hora, tipo) {
      const tipoMensagem = tipo === this.$t('tripOperation.departure') ? this.$t('tripOperation.departure') : this.$t('tripOperation.arrival');
      if (hora == null) {
        if (
          (tipo === this.$t('tripOperation.departure') && (this.operacao === 1 || this.operacao === 3)) ||
          (tipo === this.$t('tripOperation.arrival') && this.operacao === 2)
        ) {
          return this.$t('tripOperation.validation.timeRequired', { type: tipoMensagem });
        }
        return true;
      }
      else {
        if (hora.length === 0) {
          return this.$t('tripOperation.validation.timeRequired', { type: tipoMensagem });
        }
        else {
          if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
            return this.$t('tripOperation.validation.invalidTime');
          }
          else {
            return this.comparaHorarios();
          }
        }
      }
    },
    comparaHorarios() {
      if (this.editedItem.horario_chegada_realizado !== null && this.editedItem.horario_chegada_realizado <= this.editedItem.horario_saida_realizado) {
        return this.$t('tripOperation.validation.arrivalAfterDeparture');
      }

      return true;
    },
    guiaChanged() {
      let guia = this.guiasFiltered.find((g) => this.editedItem.id_guia === g.id_guia);
      if (guia) {
        this.editedItem.id_veiculo = guia.id_veiculo;
        this.editedItem.numero_ordem = guia.cod_veiculo;
        this.editedItem.id_funcionario_motorista = guia.id_motorista;
        this.editedItem.id_funcionario_cobrador = guia.id_cobrador;
        if (this.operacao === 3) this.editedItem.escalonamento = guia.escalonamento;
      }
    },
    linhaFiltroNaoAssociadasChanged() {
      if (this.linhaFiltroNaoAssociadas !== null) {
        this.viagensNaoAssociadasFiltered = this.viagensNaoAssociadas.filter((v) => v.id_linha === this.linhaFiltroNaoAssociadas);
      } else {
        this.viagensNaoAssociadasFiltered = this.viagensNaoAssociadas;
      }
    },
    adicionaViagemExtra() {
      this.operacao = 3;
      this.horarioChegadaRealizadoDisabled = true;
      this.horarioSaidaRealizadoDisabled = false;
      this.guiasFiltered = [];
      this.guiaSelectDisabled = false;
      this.linhaDisabled = false;
      this.sentidoDisabled = false;
      this.dialog = true;
      this.populaEntradasDiario();
    },
    linhaChanged() {
      this.guiasFiltered = this.guias.filter((g) => g.id_linha === this.editedItem.id_linha);
      this.populaCercasPorLinha(this.editedItem.id_linha);
    },
    populaCercasPorLinha(id) {
      this.loadingcercas = true;
      apiController.request(apiController.endpoints.getCercasporlinha, {
        data: [id],
        onSuccess: (response) => {
          this.cercasLinha = response.data;
          this.loadingcercas = false;
        },
        onError: () => {
          this.loadingcercas = false;
        },
      });
    },
    abrirPlotagemViagem(viagem) {
      this.$router.push({ path: "/relplotagem", query: { 
        idempresa: viagem.id_empresa, 
        idveiculo: viagem.id_veiculo,
        dti: viagem.horario_saida_prevista || viagem.dt_inicio,
        dtf: viagem.horario_chegada_prevista || viagem.dt_fim
      }});
    },
    abrirRelatorioViagem(viagem) {
      this.editedItem = Object.assign({}, viagem);
      this.viagem = Object.assign({}, viagem);
      this.viagem.horario_saida_realizada = viagem.dt_inicio || viagem.horario_saida_previsto;
      this.viagem.horario_chegada_realizada = viagem.dt_fim || viagem.horario_chegada_previsto;
      this.relatorioKey === 0 ? this.relatorioKey = 1 : this.relatorioKey = 0;
      this.dialogRelatorio = true;
    },
    closeRelatorio() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.dialogRelatorio = false;
    },
    getColor(item) {
      // if (item.validador_offline === 1) {
      //   return "red";
      // } 

      if (item.gps_offline === 1) {
        return "orange";
      }

      return null;
    },
    veiculoOfflineClicked(item) {
      if ((item.gps_offline === 1 || item.validador_offline === 1) &&
        item.horario_chegada_previsto >= this.now.substring(11) &&
        (item.dt_inicio === null || item.dt_fim === null)) {
        this.editedIndex = this.filteredViagens.indexOf(item);
        this.editedItem = Object.assign({}, item);
        if (this.editedItem.dt_inicio === null) {
          this.operacao = 1;
          this.editedItem.horario_saida_realizado = this.editedItem.horario_saida_previsto;
          this.editedItem.id_guia = this.editedItem.id_guia_prevista;
          let guia = this.guias.find((g) => this.editedItem.id_guia === g.id_guia);
          this.editedItem.id_funcionario_motorista = guia.id_motorista;
          this.editedItem.id_funcionario_cobrador = guia.id_cobrador;
        } else if (this.editedItem.dt_fim === null) {
          this.operacao = 2;
          this.editedItem.horario_chegada_realizado = this.editedItem.horario_chegada_previsto;
          this.editedItem.id_motivo_chegada = 1;
        }
        this.itemDiario.id_tipo_entrada_diario = 1;
        this.itemDiario.id_motivo = 1;
        this.dtEntradaDiario = DateUtils.getDateSQLFormatted(new Date());
        this.formValidado = true;
        this.diarioFormValidado = true;
        this.saveEntrada();
        this.save();
      }
    },
    showResult(resp) {
      EventBus.$emit('show-alert', {
        tipo: resp.erro ? 'error' : 'success',
        mensagem: resp.mensagem
      });
    },
    saveEntrada() {
      this.diarioFormValidado = this.$refs.diarioForm.validate();
      if (this.diarioFormValidado) {
        this.itemDiario.dt_entrada = DateUtils.getDateSQLFormatted(this.dtEntradaDiario);
        this.itemDiario.id_usuario_inclusao = this.user.id_usuario;

        apiController.request(apiController.endpoints.insertEntrada, {
          data: this.itemDiario,
          onSuccess: (response) => {
            if (this.editedItem.id_linha) {
              let entradasLinhas = [[response.data.insertId, this.editedItem.id_linha]];
              this.saveLinhasEntrada(entradasLinhas);
            }

            if (this.editedItem.id_veiculo) {
              let entradasVeiculos = [[response.data.insertId, this.editedItem.id_veiculo]];
              this.saveVeiculosEntrada(entradasVeiculos);
            }

            if (this.editedItem.id_viagem_realizada) {
              let entradasViagens = [[response.data.insertId, this.editedItem.id_viagem_realizada]];
              this.saveViagensEntrada(entradasViagens);
            }

            this.entradasDiario.push({
              id_entrada_diario: response.data.insertId,
              id_tipo_entrada_diario: this.itemDiario.id_tipo_entrada_diario,
              descricao_tipo_entrada: this.tiposEntradaDiario.find((t) => t.id_tipo_entrada_diario == this.itemDiario.id_tipo_entrada_diario).descricao_tipo_entrada,
              id_motivo: this.itemDiario.id_motivo,
              descricao_motivo: this.motivos.find((m) => m.id_motivos = this.itemDiario.id_motivo).descricao_motivo,
              dt_entrada: this.formatDateString(this.itemDiario.dt_entrada),
              observacoes: this.itemDiario.observacoes
            });
            this.itemDiario = Object.assign({}, this.defaultItemDiario);
            this.$refs.diarioForm.resetValidation();
          },
        });
      }
    },
    formatDateString(dateString) {
      let year = dateString.substring(0, 4);
      let month = dateString.substring(4, 6);
      let day = dateString.substring(6, 8);
      let hour = dateString.substring(8, 10);
      let minute = dateString.substring(10, 12);
      let second = dateString.substring(12, 14);

      return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
    },
    saveLinhasEntrada(entradasLinhas) {
      apiController.request(apiController.endpoints.insertLinhasentradabulk, {
        data: entradasLinhas,
      });
    },
    saveVeiculosEntrada(entradasVeiculos) {
      apiController.request(apiController.endpoints.insertVeiculosentradabulk, {
        data: entradasVeiculos,
      });
    },
    saveViagensEntrada(entradasViagens) {
      apiController.request(apiController.endpoints.insertViagensrealizadasentradabulk, {
        data: entradasViagens,
      });
    },
    preencheEntradas(idViagemRealizada) {
      if (this.entradasDiario.length > 0) {
        let entradasVeiculos = this.entradasDiario.map((e) => {
          if (!e.id_veiculo) {
            return [e.id_entrada_diario, this.editedItem.id_veiculo];
          }
        });

        if (entradasVeiculos.length > 0) {
          this.saveVeiculosEntrada(entradasVeiculos);
        }

        let entradasLinhas = this.entradasDiario.map((e) => {
          if (!e.id_linha) {
            return [e.id_entrada_diario, this.editedItem.id_linha];
          }
        });

        if (entradasLinhas.length > 0) {
          this.saveLinhasEntrada(entradasLinhas);
        }

        let entradasViagens = this.entradasDiario.map((e) => {
          if (!e.id_viagem_realizada) {
            return [e.id_entrada_diario, idViagemRealizada]
          }
        });

        if (entradasViagens.length > 0) {
          this.saveViagensEntrada(entradasViagens);
        }
      }
    },
    populaEntradasDiario() {
      this.loadingDiario = true;
      let today = DateUtils.getDateSQLFormatted(new Date());
      let dataInicial = today.substring(0, 8) + "000000";
      let dataFinal = today;

      let body = {
        dti: dataInicial,
        dtf: dataFinal,
        idlinhas: null,
        idveiculos: null
      }

      if (this.editedItem.id_viagem_realizada) {
        body.idviagensrealizadas = [this.editedItem.id_viagem_realizada];
      } else {
        body.idviagensprevistas = [this.editedItem.id_viagem_prevista];
      }

      apiController.request(apiController.endpoints.getEntradaspordata, {
        data: body,
        onSuccess: (response) => {
          this.entradasDiario = response.data;
          this.entradasDiario.forEach(entrada => {
            entrada.descricao_tipo_entrada = translateDbField(
              entrada.translation_key_tipo_entrada,
              entrada.descricao_tipo_entrada
            );
            return entrada;
          });
          this.loadingDiario = false;
        },
        onError: () => {
          this.loadingDiario = false;
        },
      });
    },
    getViagemClass(item) {
      if (item.status == 1) {
        return "viagem__atrasada__style";
      }

      if (item.status == 2) {
        return "viagem__aberta__style";
      }

      if (item.status == 3) {
        return "viagem__realizada__style";
      }

      if (item.status == 4) {
        return "viagem__nao__realizada__style";
      }

      return null;
    },
    desassociarChanged() {
      if (this.desassociarViagem) {
        this.horarioChegadaRealizadoDisabled = true;
        this.horarioSaidaRealizadoDisabled = true;
        this.motivoChegadaDisabled = true;
        this.motivoSaidaDisabled = true;
        this.guiaSelectDisabled = true;
        this.cercaInicioDisabled = true;
        this.cercaChegadaDisabled = true;
        this.linhaDisabled = true;
        this.sentidoDisabled = true;
      } else {
        this.horarioChegadaRealizadoDisabled = true;
        this.horarioSaidaRealizadoDisabled = true;
        this.cercaInicioDisabled = true;
        this.cercaChegadaDisabled = true;
        this.guiaSelectDisabled = true;
        this.linhaDisabled = true;
        this.sentidoDisabled = true;
        this.motivoChegadaDisabled = false;
        this.motivoSaidaDisabled = false;
      }
    },
    headersChanged(updatedHeaders) {
      if (updatedHeaders) {
        updatedHeaders.forEach((updated) => {
          const match = this.headers.find((h) => h.value === updated.value);
          if (match) match.show = updated.show;
        });
      }
      sessionStorage.setItem("headersGrid", JSON.stringify(this.headers));
    },
    filtroProximasSaidasClicked() {
      if (this.mostrarProximasSaidas) {
        this.mostrarProximasSaidas = false;
      } else {
        this.proximasSaidasDialog = true;
      }
    },
    filtrarProximasSaidas() {
      this.mostrarProximasSaidas = true;
      this.proximasSaidasDialog = false;
    },
    getEtaFormatted(eta) {
      if (!eta) {
        return null;
      }

      let hours = Math.round(eta / 3600);
      let minutes = Math.round((eta % 3600) / 60);

      if (hours === 0 && minutes === 0) {
        return this.$t('datetime.now');
      }

      let hoursFormatted = hours < 10 ? '0' + hours.toString() : hours.toString();
      let minutesFormatted = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
      return `${hoursFormatted}:${minutesFormatted}`
    },
    viagemUpdated(viagem) {
      console.log(viagem);
      this.populaLinhas();
    },
  }
}
</script>

<style>
.input__filter {
  font-size: smaller;
}

.viagem__atrasada__style {
  color: #c62828;
  font-weight: bold;
}

.viagem__aberta__style {
  color: #ff6f00;
  font-weight: bold;
}

.viagem__nao__realizada__style {
  color: #4a4a4a;
}

.viagem__realizada__style {
  color: #2e7d32;
  font-weight: bold;
}
</style>
